<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  @import './assets/css/index.css';
</style>



// WEBPACK FOOTER //
// src/App.vue